export const STORAGE_KEYS = {
  ACCESS_TOKEN: "erpgold.accessToken",
  REFRESH_TOKEN: "erpgold.refreshToken",
  TENANT_ID: "erpgold.tenantId",
  CART_SESSION_ID: "erpgold.cartSessionId",
  MAINTENANCE_MESSAGE: "erpgold.maintenanceMessage",
  PERSIST_ROOT: "erpgold-customer-root",
  MOCK_AUTH_USERS: "erpgold.mockAuthUsers",
  MOCK_LOGIN_OTP: "erpgold.mockLoginOtp",
  MOCK_GOOGLE_LOGIN: "erpgold.mockGoogleLogin",
  MOCK_GOOGLE_PHONE_OTP: "erpgold.mockGooglePhoneOtp",
  MOCK_PASSWORD_RESET: "erpgold.mockPasswordReset",
  MOCK_CART_SESSION: "erpgold.mockCartSession",
  MOCK_USER_CARTS: "erpgold.mockUserCarts",
  MOCK_ORDERS: "erpgold.mockOrders",
  MOCK_ACCOUNT_ADDRESSES: "erpgold.mockAccountAddresses",
  CHECKOUT_TRANSFER_SESSION: "erpgold.checkoutTransferSession",
} as const;
